export default __webpack_public_path__ + "static/case-cloud-1-359a3952440638adb64fa2fae3fa61f6.jpg";